module.exports = __webpack_public_path__ + "static/media/defaultAvatar.3a88b763.svg";